import ProductFilter from "./product-filter"

export class GroupedEnumProductFilterModel extends ProductFilter {
  constructor(groups, products) {
    super(
      {
        strapiId: "grouped_" + groups[0]._id,
        name: groups[0].name,
        info: groups[0].info,
        order: groups[0].order,
      },
      "ENUM",
    )

    this._groups = groups

    for (let group of groups) {
      this.values.push(...group.values)
      this.selected.push(...group.selected)
      this._displayValues.push(...group._displayValues)
    }

    this._ids = groups.map((group) => group._id + "")

    this.updateValues([], products)
  }

  _groups
  _ids = []
  values = []
  selected = []
  _displayValues = []

  select(value) {
    if (
      !this._includesValue(this.values, value) ||
      this._includesValue(this.selected, value)
    )
      return
    this.selected.push(value)
    this._updated()
  }

  unselect(value) {
    const index = this._indexOf(this.selected, value)
    if (index === -1) return
    this.selected.splice(index, 1)
    this._updated(this.selected.length !== 0)
  }

  reset() {
    this.selected = []
    this._displayValues = this.values.map((v) => v)
    super.reset()
  }

  matches(product) {
    for (let i = 0; i < product.enum_product_parameter_values.length; i++) {
      const param = product.enum_product_parameter_values[i]
      if (!this._ids.includes(param.product_parameter_group.id + "")) continue
      if (this._includesValue(this.selected, param.value)) return true
    }

    return false
  }

  hasEffectOn(product) {
    const index = product.enum_product_parameter_values.findIndex((param) =>
      this._ids.includes(param.product_parameter_group.id + ""),
    )

    return index !== -1
  }

  /**
   * This function is called if the products list updates.
   * @param products new list of products
   * @param filteredProductsWithoutCurrent
   */
  updateValues(
    products,
    filteredProductsWithoutCurrent,
    marketFilter,
    preselectedMarkets,
  ) {
    const displayValues = []
    for (let group of this._groups) {
      group.updateValues(
        products,
        filteredProductsWithoutCurrent,
        marketFilter,
        preselectedMarkets,
      )
      // group may be relevant even if it has only 1 display value -> use isHiddenByParent instead of isHidden
      if (!group.isHiddenByParent()) {
        displayValues.push(...group._displayValues)
      }
    }

    this._displayValues = displayValues
  }

  isHiddenByParent() {
    for (let group of this._groups) {
      if (!group.isHiddenByParent()) {
        return false
      }
    }
    return true
  }

  isHidden() {
    let notDisabledCount = 0

    for (const value of this.values) {
      if (!this.isDisabled(value)) {
        notDisabledCount++
        if (notDisabledCount > 1) break
      }
    }

    return super.isHidden() || (!this._isActive && notDisabledCount <= 1)
  }

  isSelected(value) {
    return this._includesValue(this.selected, value)
  }

  isDisabled(value) {
    return (
      !this._includesValue(this.selected, value) &&
      !this._includesValue(this._displayValues, value)
    )
  }

  getState() {
    return {
      ...super.getState(),
      selected: this.selected,
      _displayValues: this._displayValues,
    }
  }

  restoreState(state) {
    super.restoreState(state)
    this.selected = state.selected || []
    this._displayValues = state._displayValues || []
  }
}
